'use client';

import { useContext } from 'react';
import { AuthContext } from '@/contexts/AuthContext';

export function useAuth() {
  const context = useContext(AuthContext);

  // During SSR or when AuthProvider is not available, return safe defaults
  if (!context) {
    // Check if we're in the browser and AuthProvider should be available
    if (typeof window !== 'undefined') {
      // On client-side, if no context, it means AuthProvider is missing
      // Return safe defaults instead of throwing to prevent crashes
      console.warn(
        'useAuth called without AuthProvider - returning safe defaults'
      );
      return {
        user: null,
        token: null,
        isAuthenticated: false,
        isInitialized: false, // Add this
        login: async () => {
          throw new Error('AuthProvider not available');
        },
        loginWithGoogle: async () => {
          throw new Error('AuthProvider not available');
        },
        logout: () => {
          console.warn('logout called without AuthProvider');
        },
        updateUser: () => {
          console.warn('updateUser called without AuthProvider');
        },
      };
    }

    // SSR - return safe defaults
    return {
      user: null,
      token: null,
      isAuthenticated: false,
      isInitialized: false, // Add this
      login: async () => {},
      loginWithGoogle: async () => {},
      logout: () => {},
      updateUser: () => {},
    };
  }

  return context;
}
